module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Posat-e00aab5a5c461127f50e135ee794b3e3.png";